import { PolicyTemplate } from '../../../../types/policies';
import { useGet } from '../../../../api';
import { TEMPLATES_BASE_URL } from '../consts';

export const useGetPolicyTemplates = () => {
    const {
        error,
        loading,
        data: templates,
        fetchData: fetchTemplates
    } = useGet<PolicyTemplate[]>({ url: TEMPLATES_BASE_URL });

    return {
        error,
        loading,
        templates,
        fetchTemplates
    };
};
